import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetExamsProviderLocation,
	GetExamsProviderLocationParams,
	GetExamsProviderLocationModel,
} from 'domain/usecases';

export class RemoteGetExamsProviderLocation implements GetExamsProviderLocation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsProviderLocationModel>,
	) {}

	async get({
		signal,
		...params
	}: GetExamsProviderLocationParams): Promise<GetExamsProviderLocationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
